import { PerformancePeerAssignmentsAvatarStackFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

export const getMemberAvatarsFragment = (
  avatars: (PerformancePeerAssignmentsAvatarStackFragment | undefined | null)[]
) => {
  const avatarStack = avatars.map((member) => {
    if (!member)
      return {
        label: i18n.t('performance_process.reviews.evaluations.anonymous'),
        url: null,
      }
    return {
      label: member.fullName,
      url: buildUrl(member.avatar?.url),
    }
  })

  return avatarStack
}
